module.exports = __webpack_public_path__ + "img/20200911_140612.b34c3109.jpg";